  <p-splitButton [label]="$any(currentPriorityName$ | async)" appendTo="body" [model]="menuItems()" [size]="size" [styleClass]="'p-button-outlined '">
  </p-splitButton>
  